import React from "react";
import { useState, useEffect, useMemo } from "react";
import { getRequest } from "sharedUtils/httpUtils";
import { QRCodeCanvas } from "qrcode.react";

import TwitterIcon from "components/icons/TwitterIcon";
import FacebookIcon from "components/icons/FacebookIcon";
import MobileShare from "components/MobileShare";
import MailIcon from "components/icons/MailIcon";
import { getProperties } from "sharedUtils/postFunctions";
import { trimProductsArray } from "sharedUtils/postFunctions";

/**
 * @param {{loggedInUser: Object, title:string, shareCode:string?, customStyle:Object, shareBlockStyle:Object, isUserMerchant?: boolean, merchantLogoUrl?: string}} props
 */
const ShareBlock = (props) => {
    const [qrImage, setQrImage] = useState(null);

    const qrCodeRefCallback = (node) => {
        if (node) {
            const canvas = node.querySelector("canvas");
            if (canvas) {
                setTimeout(() => {
                    const image = canvas.toDataURL("image/png");
                    setQrImage(image);
                }, 200);
            } else {
                console.warn("Canvas not found inside QR Code element.");
            }
        } else {
            console.warn("QR Code ref callback received null (likely unmounted).");
        }
    };

    const [showCopied, setCopiedText] = useState(false);
    const [showCopied2, setCopiedText2] = useState(false);
    const [showCopied3, setCopiedText3] = useState(false);
    const [showCopied4, setCopiedText4] = useState(false);
    const [renderDirect, setRenderDirect] = useState(false);

    const [postEmbedCode, setPostEmbedCode] = useState(null);
    const [lockerEmbedCode, setLockerEmbedCode] = useState(null);
    const [productEmbedCode, setProductEmbedCode] = useState(null);
    const [postEmbedBrandCode, setPostEmbedBrandCode] = useState(null);
    const [blogEmbedCode, setBlogEmbedCode] = useState(null);
    const [lockerEmbedBrandCode, setLockerEmbedBrandCode] = useState(null);
    const [productEmbedBrandCode, setProductEmbedBrandCode] = useState(null);
    const [profileEmbedCode, setProfileEmbedCode] = useState(null);
    const [merchantEmbedCode, setMerchantEmbedCode] = useState(null);
    const [referralShareCode, setReferralShareCode] = useState(null);
    const [shareCode, setShareCode] = useState(null);
    const [shareType, setShareType] = useState("");
    const [emailEmbedCode, setEmailEmbedCode] = useState(null);

    // UTM state
    const [utmId, setUtmId] = useState("");
    const [utmSource, setUtmSource] = useState("");
    const [utmMedium, setUtmMedium] = useState("");
    const [utmName, setUtmName] = useState("");
    const [utmContent, setUtmContent] = useState("");
    const [utmTerm, setUtmTerm] = useState("");
    const [advOpen, setAdvOpen] = useState(false);

    const [testCode, setTestCode] = useState(null);

    // Build URL with UTMs (single, correct encoding pass)
    const applyUtmsToUrl = (u) => {
        if (!u) return u;
        try {
            const url = new URL(u, window.location.origin);
            const sp = url.searchParams;

            ["utm_id", "utm_source", "utm_medium", "utm_name", "utm_content", "utm_term"].forEach((k) =>
                sp.delete(k)
            );

            const add = (k, v) => {
                const t = (v ?? "").trim();
                if (t) sp.append(k, t);
            };
            add("utm_id", utmId);
            add("utm_source", utmSource);
            add("utm_medium", utmMedium);
            add("utm_name", utmName);
            add("utm_content", utmContent);
            add("utm_term", utmTerm);

            url.search = sp.toString(); // spaces -> +
            return url.toString();
        } catch {
            // Relative URL fallback
            const idx = u.indexOf("#");
            const base = idx === -1 ? u : u.slice(0, idx);
            const hash = idx === -1 ? "" : u.slice(idx);

            const params = new URLSearchParams(base.includes("?") ? base.split("?")[1] : "");
            ["utm_id", "utm_source", "utm_medium", "utm_name", "utm_content", "utm_term"].forEach((k) =>
                params.delete(k)
            );

            const add = (k, v) => {
                const t = (v ?? "").trim();
                if (t) params.append(k, t);
            };
            add("utm_id", utmId);
            add("utm_source", utmSource);
            add("utm_medium", utmMedium);
            add("utm_name", utmName);
            add("utm_content", utmContent);
            add("utm_term", utmTerm);

            const baseNoQs = base.split("?")[0];
            const qs = params.toString();
            const sep = qs ? "?" : "";
            return `${baseNoQs}${sep}${qs}${hash}`;
        }
    };

    // Derived link including UTMs (recomputes when base or UTMs change)
    const shareCodeWithUtms = useMemo(
        () => applyUtmsToUrl(shareCode),
        [shareCode, utmId, utmSource, utmMedium, utmName, utmContent, utmTerm]
    );

    const MAX_UTM_LEN = 255;
    const remaining = (v) => Math.max(0, MAX_UTM_LEN - (v ?? "").length);

    const extractEmbeddedUsernames = (text) => {
        return text.replace(/#!\^.*?@\(\(\((.*?)\)\)\)/g, "@$1");
    };

    const GetPostEmailHtml = async (type) => {
        const html = `<div style="max-width:600px;margin:0 auto;border:1px solid lightgray;border-radius:15px;"><a href="{{{shareLink}}}" style="text-decoration:none;cursor:pointer;" target="_blank"><table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td style="text-align:center;padding:20px 0;"><img src="https://app.rockporch.com/images/rockporch-logo.png" width="162" style="display:block;margin:0 auto;border:0;" alt="Logo" /></td></tr></table><table role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td style="text-align:center;padding:10px 25px;"><img src="{{{bannerImage}}}" width="550" style="width:100%;max-width:550px;border:0;display:block;object-fit:cover;max-height:500px;" alt="" /></td></tr><!-- Title --><tr><td style="text-align:center;font-family:Helvetica;font-size:24px;color:#000000;padding:0 20px;">{{{title}}}</td></tr><!-- End Title --><!-- Subtitle --><tr><td style="text-align:center;font-family:Helvetica;font-size:15px;color:#000000;padding:10px 20px;">{{{subTitle}}}</td></tr><!-- End Subtitle --><!-- productButton --><tr><td align="center" style="padding:10px 0;"><table role="presentation" cellpadding="0" cellspacing="0" style="border-collapse:separate;line-height:100%;"><tr><td align="center" bgcolor="#da4100" style="opacity:0.8;border-radius:40px;background:#da4100;padding:10px 25px;color:#ffffff;font-family:Helvetica;font-size:12px;">{{{productCount}}}</td></tr></table></td></tr><!-- End productButton --></table><table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td align="center" style="padding:10px 0;"><!--[if mso]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><![endif]--><!-- Product 1 --><table role="presentation" border="0" cellpadding="0" cellspacing="0" align="left" width="100%" style="max-width:190px;display:inline-block;vertical-align:top;margin:0 auto;"><tr><td style="padding:10px;text-align:center;"><div style="margin-left:12px;width:100%;padding:10px;border:1px solid lightgray;border-radius:15px;"><img src="{{{productImage1}}}" width="120" style="display:block;margin:0 auto;max-width:120px;max-height:120px;object-fit:contain;min-width:120px;min-height:120px;" alt="Product 1" /></div></td></tr></table><!-- End Product 1 --><!-- Product 2 --><table role="presentation" border="0" cellpadding="0" cellspacing="0" align="left" width="100%" style="max-width:190px;display:inline-block;vertical-align:top;margin:0 auto;"><tr><td style="padding:10px;text-align:center;"><div style="margin-left:12px;width:100%;padding:10px;border:1px solid lightgray;border-radius:15px;"><img src="{{{productImage2}}}" width="120" style="display:block;margin:0 auto;max-width:120px;max-height:120px;object-fit:contain;min-width:120px;min-height:120px;;" alt="Product 2" /></div></td></tr></table><!-- End Product 2 --><!-- Product 3 --><table role="presentation" border="0" cellpadding="0" cellspacing="0" align="left" width="100%" style="max-width:190px;display:inline-block;vertical-align:top;margin:0 auto;"><tr><td style="padding:10px;text-align:center;"><div style="margin-left:12px;width:100%;padding:10px;border:1px solid lightgray;border-radius:15px;"><img src="{{{productImage3}}}" width="120" style="display:block;margin:0 auto;max-width:120px;max-height:120px;object-fit:cover;min-width:120px;min-height:120px;" alt="Product 3" /></div></td></tr></table><!-- End Product 3 --><!--[if mso]></tr></table><![endif]--></td></tr></table></a></div>`;
        const shareCodeRaw = shareCode; // use current state (may have subdomain swap)
        let parsedShareCode = shareCodeRaw.slice(shareCodeRaw.lastIndexOf("/") + 1);
        if (parsedShareCode.includes("?")) parsedShareCode = parsedShareCode.slice(0, parsedShareCode.indexOf("?"));

        const url = `/api/post/getPost?shareCode=${parsedShareCode}&referrer=null&noTracking=true`;
        const post = await getRequest(url);
        if (!post) return "";

        const properties = getProperties(post.properties).reverse();
        const bannerImage =
            properties.find((p) => p?.parentId == null && (p?.role === 0 || p?.role === 8))?.value || null;

        if (!bannerImage) return;

        let title = "";
        let subTitle = "";

        if (type === "post") {
            title = post.content?.trim() || "";
            subTitle = ""; // Posts don't use a subtitle
        } else {
            title = post.title?.trim() || "";
            subTitle = post.content?.trim() || "";
        }

        const products =
            trimProductsArray(post.productItems?.$values)?.sort((a, b) => a.ordinal - b.ordinal) || [];

        const productImages = products.slice(0, 3).map((p) => p.imageUrl);
        let productCount = "";
        if (products?.length > 1) productCount = products.length + " Products";
        else if (products.length > 0) productCount = "1 Product";

        let updatedHtml = html
            .replace("{{{shareLink}}}", shareCodeWithUtms || shareCode) // UTMs in email link
            .replace("{{{bannerImage}}}", bannerImage)
            .replace("{{{productCount}}}", productCount)
            .replace("{{{title}}}", extractEmbeddedUsernames(title))
            .replace("{{{subTitle}}}", extractEmbeddedUsernames(subTitle));

        if (!title) updatedHtml = updatedHtml.replace(/<!-- Title -->[\s\S]*?<!-- End Title -->/, "");
        if (!subTitle) updatedHtml = updatedHtml.replace(/<!-- Subtitle -->[\s\S]*?<!-- End Subtitle -->/, "");
        if (!productCount) {
            updatedHtml = updatedHtml.replace(/<!-- productButton -->[\s\S]*?<!-- End productButton -->/, "");
        }

        productImages.forEach((img, index) => {
            updatedHtml = updatedHtml.replace(`{{{productImage${index + 1}}}}`, img);
        });

        for (let i = productImages.length + 1; i <= 3; i++) {
            const regex = new RegExp(`<!-- Product ${i} -->[\\s\\S]*?<!-- End Product ${i} -->`, "g");
            updatedHtml = updatedHtml.replace(regex, "");
        }

        setEmailEmbedCode(updatedHtml);
    };

    const GetProductEmailHtml = async () => {
        let html = `<div style="max-width:600px;margin:0 auto;border:1px solid lightgray;border-radius:15px;padding-bottom:20px;"><a href="{{{shareLink}}}" style="text-decoration:none;cursor:pointer;" target="_blank"><table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td style="text-align:center;padding:20px 0;"><img src="https://app.rockporch.com/images/rockporch-logo.png" width="162" style="display:block;margin:0 auto;border:0;" alt="Logo" /></td></tr></table><table role="presentation" border="0" cellpadding="0" cellspacing="0" style="width:100%;max-width:600px;"><tr><td style="text-align:center;padding:10px 25px;"><img src="{{{productImage}}}" width="550" style="width:100%;max-width:550px;border:0;display:block;object-fit:cover;max-height:500px;" alt="" /></td></tr><tr><td style="text-align:center;font-family:Helvetica,Arial,sans-serif;font-size:15px;color:#000000;padding:10px 20px;">{{{merchant}}}</td></tr><tr><td style="text-align:center;font-family:Helvetica,Arial,sans-serif;font-size:24px;color:#000000;padding:0 20px;">{{{productName}}}</td></tr></table></a></div>`;
        const shareCodeRaw = shareCode;
        let parsedShareCode = shareCodeRaw.slice(shareCodeRaw.lastIndexOf("/") + 1);
        if (parsedShareCode.includes("?")) parsedShareCode = parsedShareCode.slice(0, parsedShareCode.indexOf("?"));
        if (!parsedShareCode) return;

        const url = `/Products/Get?shareCode=${parsedShareCode}&noTracking=true`;
        const product = await getRequest(url);
        if (!product) return;

        const productImage = product.imageUrl;
        if (!productImage) return;

        let merchant = product.merchant;
        let productName = product.name;

        let updatedHtml = html
            .replace("{{{shareLink}}}", shareCodeWithUtms || shareCode) // UTMs in email link
            .replace("{{{productImage}}}", productImage)
            .replace("{{{merchant}}}", merchant)
            .replace("{{{productName}}}", productName);

        if (!merchant) updatedHtml = updatedHtml.replace(/<!-- Merchant -->[\s\S]*?<!-- End Merchant -->/, "");
        if (!productName) {
            updatedHtml = updatedHtml.replace(/<!-- ProductName -->[\s\S]*?<!-- End ProductName -->/, "");
        }

        setEmailEmbedCode(updatedHtml);
    };

    const GetPostBlogEmbed = async (type = "post") => {
        let html = `<div><style>@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@400;500;700&display=swap');</style><a href="{{{postPageRedirect}}}" target="_blank" rel="noreferrer" style="text-decoration:none;color:black;"><div style="max-width:450px;border:1px solid lightgray;border-radius:15px;padding:5px 20px;"><div><div style="display:flex;align-items:center;"><div><div style="width:100%;overflow:hidden;vertical-align:middle;display:inline-flex;align-items:center;"><div><img src="{{{profilePic}}}" alt="avatar" loading="lazy" style="width:24px!important;height:24px!important;object-fit:cover;border-radius:50%;margin-right:8px;" data-f1="{{{profilePicBackup}}}" data-f2="https://app.rockporch.com/images/avatar2.svg" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></div><h5><div><div style="display:table;table-layout:fixed;width:100%;"><div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:table-cell;color:black; font-family: 'Urbanist', sans-serif;">{{{profileUserName}}}</div></div></div></h5></div></div><div><img src="https://app.rockporch.com/static/media/rockporch-logo-new.a0b95b41.svg" alt=""></div></div><div style="cursor:pointer;"><img src="{{{postPageBanner}}}" alt="Responsive" loading="lazy" style="width: 100%; aspect-ratio:{{{aspectRatio}}}; object-fit: cover; object-position: 50% 25%;" data-f1="{{{postPageBannerBackup}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></div></div><div style="cursor:pointer;"><button style="margin-left:6px;margin-top:{{{buttonMarginTop}}};margin-bottom:{{{buttonMarginBottom}}};background-color:#da4100;color:#fff;border:1px solid #da4100;font-size:16px;padding:8px 11px;cursor:pointer;font-family: 'Urbanist', sans-serif;">View on RockPorch</button></div><!-- Title --><div style="cursor:pointer;"><p style="margin-top:16px;text-overflow:ellipsis;overflow:hidden;padding-left:6px;padding-right:6px;white-space:nowrap;max-width:500px;font-family:'Urbanist',sans-serif;">{{{title}}}</p></div><!-- End Title --><div style="border-radius:20px;overflow:hidden;cursor:pointer;"><div style="display:flex;width:100%;padding:0 5px; justify-content: center;"><!-- Product 1 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%; justify-content: center;"><div style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect1}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage1}}}" alt="Product 1" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup1}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 1 --><!-- Product 2 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%;"><div class="product-image" style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect2}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage2}}}" alt="Product 2" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup2}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 2 --><!-- Product 3 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%;"><div class="product-image" style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect3}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage3}}}" alt="Product 3" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup3}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 3 --></div></div></div></a></div>`;

        if (type === "locker") {
            html = `<div><style>@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@400;500;700&display=swap');</style><a href="{{{postPageRedirect}}}" target="_blank" rel="noreferrer" style="text-decoration:none;color:black;"><div style="max-width:450px;border:1px solid lightgray;border-radius:15px;padding:5px 20px;"><div><div style="display:flex;align-items:center;"><div><div style="width:100%;overflow:hidden;vertical-align:middle;display:inline-flex;align-items:center;"><div><img src="{{{profilePic}}}" alt="avatar" loading="lazy" style="width:24px!important;height:24px!important;object-fit:cover;border-radius:50%;margin-right:8px;" data-f1="{{{profilePicBackup}}}" data-f2="https://app.rockporch.com/images/avatar2.svg" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></div><h5><div><div style="display:table;table-layout:fixed;width:100%;"><div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:table-cell;color:black; font-family: 'Urbanist', sans-serif;">{{{profileUserName}}}</div></div></div></h5></div></div><div><img src="https://app.rockporch.com/static/media/rockporch-logo-new.a0b95b41.svg" alt=""></div></div><div style="cursor:pointer; position: relative;"><img src="{{{postPageBanner}}}" alt="Responsive" loading="lazy" style="width: 100%; aspect-ratio:{{{aspectRatio}}}; object-fit: cover; object-position: 50% 25%;filter: brightness(50%);" data-f1="{{{postPageBannerBackup}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"><h3 style="position: absolute; cursor: pointer; top: 40%; left: 50%; margin-bottom: 0; transform: translate(-50%, -50%); color: #fff; text-align: center; width: 90%; padding: 0 15px; font-family: 'Urbanist', sans-serif; font-size: 24px; font-weight: 500;">{{{title}}}</h3><span style="position: absolute; cursor: pointer; bottom: 0; left: 50%; margin-bottom: 0; transform: translate(-50%, -50%); width: 37%; border-radius: 999px; text-align: center; background-color: #da4100; font-family: 'Urbanist', sans-serif; font-size: .75rem; font-weight: 500; color: #fff; opacity: .8; padding: 2px 0;">{{{productCount}}}</span></div></div><div style="cursor:pointer;"><button style="margin-left:6px;margin-top:{{{buttonMarginTop}}};background-color:#da4100;color:#fff;border:1px solid #da4100;font-size:16px;padding:8px 11px;cursor:pointer; margin-bottom: 16px;font-family: 'Urbanist', sans-serif;">View on RockPorch</button></div><div style="border-radius:20px;overflow:hidden;cursor:pointer;"><div style="display:flex;width:100%;padding:0 5px; justify-content: center;"><!-- Product 1 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%; justify-content: center;"><div style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect1}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage1}}}" alt="Product 1" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup1}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 1 --><!-- Product 2 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%;"><div class="product-image" style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect2}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage2}}}" alt="Product 2" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup2}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 2 --><!-- Product 3 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%;"><div class="product-image" style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect3}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage3}}}" alt="Product 3" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup3}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 3 --></div></div></div></a></div>`;
        }

        if (type === "blog") {
            html = `<div><style>@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@400;500;700&display=swap');</style><a href="{{{postPageRedirect}}}" target="_blank" rel="noreferrer" style="text-decoration:none;color:black;"><div style="max-width:450px;border:1px solid lightgray;border-radius:15px;padding:5px 20px;"><div><div style="display:flex;align-items:center;"><div><div style="width:100%;overflow:hidden;vertical-align:middle;display:inline-flex;align-items:center;"><div><img src="{{{profilePic}}}" alt="avatar" loading="lazy" style="width:24px!important;height:24px!important;object-fit:cover;border-radius:50%;margin-right:8px;" data-f1="{{{profilePicBackup}}}" data-f2="https://app.rockporch.com/images/avatar2.svg" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></div><h5><div><div style="display:table;table-layout:fixed;width:100%;"><div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:table-cell;color:black; font-family: 'Urbanist', sans-serif;">{{{profileUserName}}}</div></div></div></h5></div></div><div><img src="https://app.rockporch.com/static/media/rockporch-logo-new.a0b95b41.svg" alt=""></div></div><div style="cursor:pointer; position: relative;"><img src="{{{postPageBanner}}}" alt="Responsive" loading="lazy" style="width: 100%; aspect-ratio:{{{aspectRatio}}}; object-fit: cover; object-position: 50% 25%;" data-f1="{{{postPageBannerBackup}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"><h3 style="position: absolute; cursor: pointer; top: 40%; left: 50%; margin-bottom: 0; transform: translate(-50%, -50%); color: #fff; text-align: center; width: 100%; padding: 0 15px; font-family: 'Urbanist', sans-serif; font-size: 24px;width: 90%;font-weight: 500;">{{{title}}}</h3><div style="font-family: 'Urbanist', sans-serif; cursor: pointer; color: white; bottom: 20px; padding: 2% 5%; text-align: center; width: 90%; position: absolute;"><p style="color: white;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-family: 'Urbanist', sans-serif;margin: 0;">{{{description}}}</p><p style="color: white; text-decoration: underline;font-family: 'Urbanist', sans-serif;margin: 4px 0 16px 0;">Read more</p></div><!-- productButton --><span style="position: absolute; cursor: pointer; bottom: 0; left: 50%; margin-bottom: 0; transform: translate(-50%, -50%); width: 37%; border-radius: 999px; text-align: center; background-color: #da4100; font-family: 'Urbanist', sans-serif; font-size: .75rem; font-weight: 500; color: #fff; opacity: .8; padding: 2px 0;">{{{productCount}}}</span><!-- End productButton --></div></div><div style="cursor:pointer;"><button style="margin-left:6px;margin-top:{{{buttonMarginTop}}};background-color:#da4100;color:#fff;border:1px solid #da4100;font-size:16px;padding:8px 11px;cursor:pointer; margin-bottom: 16px;font-family: 'Urbanist', sans-serif;">View on RockPorch</button></div><div style="border-radius:20px;overflow:hidden;cursor:pointer;"><div style="display:flex;width:100%;padding:0 5px; justify-content: center;"><!-- Product 1 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%; justify-content: center;"><div style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect1}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage1}}}" alt="Product 1" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup1}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 1 --><!-- Product 2 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%;"><div class="product-image" style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect2}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage2}}}" alt="Product 2" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup2}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 2 --><!-- Product 3 --><div style="flex:0 0 33.3333333333%;max-width:33.3333333333%;"><div class="product-image" style="padding-bottom:100%;position:relative;overflow:hidden;margin:2px;"><a href="{{{productRedirect3}}}" target="_blank" rel="noreferrer" style="cursor:pointer;"><img src="{{{productImage3}}}" alt="Product 3" loading="lazy" style="position:absolute;width:96%;height:96%;top:0;left:0;object-fit:scale-down;border:1px solid #efecec;border-radius:10px;" data-f1="{{{productImageBackup3}}}" data-f2="https://app.rockporch.com/images/blank-banner.png" onerror="if(!this.dataset.step){ this.dataset.step=1; this.src=this.dataset.f1;} else if(this.dataset.step==='1'){ this.dataset.step=2; this.src=this.dataset.f2;} else { this.onerror=null;}"></a></div></div><!-- End Product 3 --></div></div></div></a></div>`;
        }

        const shareCodeRaw = shareCode; // use current state (may have subdomain swap)
        let parsedShareCode = shareCodeRaw.slice(shareCodeRaw.lastIndexOf("/") + 1);
        if (parsedShareCode.includes("?")) parsedShareCode = parsedShareCode.slice(0, parsedShareCode.indexOf("?"));

        const url = `/api/post/getPost?shareCode=${parsedShareCode}&referrer=null&noTracking=true`;
        const post = await getRequest(url);
        if (!post) return "";

        const properties = getProperties(post.properties).reverse();
        const bannerImage =
            properties.find((p) => p?.parentId == null && (p?.role === 0 || p?.role === 8))?.value || null;

        if (!bannerImage) return;

        let user = post.user;
        let userImage = user.imageUrl;
        let userName = user.userName;

        let title = "";
        let subTitle = "";

        if (type === "post") {
            title = post.content?.trim() || "";
            subTitle = ""; // Posts don't use a subtitle
        } else {
            title = post.title?.trim() || "";
            subTitle = post.content?.trim() || "";
        }

        const products =
            trimProductsArray(post.productItems?.$values)?.sort((a, b) => a.ordinal - b.ordinal) || [];

        const productImages = products.slice(0, 3).map((p) => p.imageUrl);

        let productRedirects = products.slice(0, 3).map(p => {
            if (!!(p.userMerchantProductId)) {
                return `https://${window.location.host}/prdlink/${p.shareCode}`;
            } else {
                return `https://${window.location.host}/mlink/${p.merchantId}?userId=${post.user.id}&redirectUrl=${encodeURIComponent(p.referralUrl)}`
            }
        })

        let productCount = "";
        if (products?.length > 1) productCount = products.length + " Products";
        else if (products.length > 0) productCount = "1 Product";

        let updatedHtml = html
            .replace("{{{postPageRedirect}}}", shareCodeWithUtms || shareCode) // UTMs in email link
            .replace("{{{profilePic}}}", userImage.includes("evolvedoutdoors") ? userImage + "-Profile" : userImage)
            .replace("{{{profilePicBackup}}}", userImage)
            .replace("{{{profileUserName}}}", userName)
            .replace("{{{postPageBanner}}}", bannerImage.includes("evolvedoutdoors") ? bannerImage + "-Post" : bannerImage )
            .replace("{{{postPageBannerBackup}}}", bannerImage)
            .replace("{{{aspectRatio}}}", products?.length > 0 ? "1/1" : "3/4")
            .replace("{{{buttonMarginTop}}}", products?.length > 0 ? "16px" : "20px")
            .replace("{{{buttonMarginBottom}}}", extractEmbeddedUsernames(title)?.length > 0 ? "0" : "16px")
            .replace("{{{productCount}}}", productCount)
            .replace("{{{title}}}", extractEmbeddedUsernames(title))
            .replace("{{{description}}}", extractEmbeddedUsernames(subTitle));

        if (!title) updatedHtml = updatedHtml.replace(/<!-- Title -->[\s\S]*?<!-- End Title -->/, "");
        if (!subTitle) updatedHtml = updatedHtml.replace(/<!-- Subtitle -->[\s\S]*?<!-- End Subtitle -->/, "");
        if (!productCount) {
            updatedHtml = updatedHtml.replace(/<!-- productButton -->[\s\S]*?<!-- End productButton -->/, "");
        }

        productImages.forEach((img, index) => {
            if (img.includes("evolvedoutdoors")) {
                updatedHtml = updatedHtml.replace(`{{{productImage${index + 1}}}}`, img + "-ProductGrid").replace(`{{{productImageBackup${index + 1}}}}`, img);
            } else {
                updatedHtml = updatedHtml.replace(`{{{productImage${index + 1}}}}`, img).replace(`{{{productImageBackup${index + 1}}}}`, img);
            }
        });

        productRedirects.forEach((url, index) => {
            updatedHtml = updatedHtml.replace(`{{{productRedirect${index + 1}}}}`, url);
        });

        for (let i = productImages.length + 1; i <= 3; i++) {
            const regex = new RegExp(`<!-- Product ${i} -->[\\s\\S]*?<!-- End Product ${i} -->`, "g");
            updatedHtml = updatedHtml.replace(regex, "");
        }
        if (type === "post") {
            setPostEmbedCode(updatedHtml);
        } else if (type === "locker") {
            setLockerEmbedCode(updatedHtml);
        } else if (type === "blog") {
            setBlogEmbedCode(updatedHtml);
        }
    }

    // ---- ALL EMBEDS USE UTM�D URLS ----
    const computeEmbedsFromShareCode = (urlWithUtms) => {
        if (!urlWithUtms) return;

        const lower = urlWithUtms.toLowerCase();
        const parsedShareCode = urlWithUtms.slice(urlWithUtms.lastIndexOf("/") + 1).split("?")[0];

        let embedHost = "";
        if (urlWithUtms.includes(".ch/")) embedHost = urlWithUtms.slice(0, urlWithUtms.indexOf(".ch/") + 4);
        else if (urlWithUtms.includes(".com/")) embedHost = urlWithUtms.slice(0, urlWithUtms.indexOf(".com/") + 5);
        else if (urlWithUtms.includes("44334/")) embedHost = urlWithUtms.slice(0, urlWithUtms.indexOf("44334/") + 6);

        // Registration
        if (lower.includes("/identity/account/register")) {
            setShareType("Registration");
        }

        // Post
        if (lower.includes("/p/") || lower.includes("/plink/")) {
            setShareType("Post");
            const idx = lower.includes("/p/") ? lower.indexOf("/p/") : lower.indexOf("/plink/");
            const baseEmbed = urlWithUtms.slice(0, idx) + "/embed" + urlWithUtms.slice(idx);
            const embedUrl = applyUtmsToUrl(baseEmbed);
            const baseBrand =
                baseEmbed.slice(0, baseEmbed.indexOf("/embed") + 6) +
                "/brand" +
                baseEmbed.slice(baseEmbed.indexOf("/embed") + 6);
            const brandUrl = applyUtmsToUrl(baseBrand);
            GetPostBlogEmbed();
            setPostEmbedBrandCode(
                `<iframe onload="sendMessage()" id="rpFrame-${parsedShareCode}" src="${brandUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:450px;"></iframe><script crossorigin="">function sendMessage(){document.querySelector("#rpFrame-${parsedShareCode}").contentWindow.postMessage("rpMessage","${embedHost}")}window.addEventListener("message",function(e){let isJson=!1;let rpJson;try{rpJson=JSON.parse(e.data);isJson=!0}catch{isJson=!1}if(isJson){if(typeof rpJson.shareCode==="string"){if(typeof rpJson.height==="number"){if(rpJson.height>0){const elements=document.querySelectorAll('iframe[id=rpFrame-'+rpJson.shareCode+']');elements.forEach(element=>{element.style.minHeight=rpJson.height+60+"px"})}}}}})</script>`
            );
            return;
        }

        // Blog
        if (lower.includes("/b/") || lower.includes("/blink/")) {
            setShareType("Blog");
            const idx = lower.includes("/b/") ? lower.indexOf("/b/") : lower.indexOf("/blink/");
            const baseEmbed = urlWithUtms.slice(0, idx) + "/embed" + urlWithUtms.slice(idx);
            const embedUrl = applyUtmsToUrl(baseEmbed);

            GetPostBlogEmbed("blog");

            return;
        }

        // Locker
        if (lower.includes("/l/") || lower.includes("/llink/")) {
            setShareType("Locker");
            const idx = lower.includes("/l/") ? lower.indexOf("/l/") : lower.indexOf("/llink/");
            const baseEmbed = urlWithUtms.slice(0, idx) + "/embed" + urlWithUtms.slice(idx);
            const embedUrl = applyUtmsToUrl(baseEmbed);
            const baseBrand =
                baseEmbed.slice(0, baseEmbed.indexOf("/embed") + 6) +
                "/brand" +
                baseEmbed.slice(baseEmbed.indexOf("/embed") + 6);
            const brandUrl = applyUtmsToUrl(baseBrand);

            GetPostBlogEmbed("locker");

            setLockerEmbedBrandCode(
                `<iframe onload="sendMessage()" id="rpFrame-${parsedShareCode}" src="${brandUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:450px;"></iframe><script crossorigin="">function sendMessage(){document.querySelector("#rpFrame-${parsedShareCode}").contentWindow.postMessage("rpMessage","${embedHost}")}window.addEventListener("message",function(e){let isJson=!1;let rpJson;try{rpJson=JSON.parse(e.data);isJson=!0}catch{isJson=!1}if(isJson){if(typeof rpJson.shareCode==="string"){if(typeof rpJson.height==="number"){if(rpJson.height>0){const elements=document.querySelectorAll('iframe[id=rpFrame-'+rpJson.shareCode+']');elements.forEach(element=>{element.style.minHeight=rpJson.height+60+"px"})}}}}})</script>`
            );
            return;
        }

        // Merchant (logo link)
        if (lower.includes("/m/") || lower.includes("/mlink/")) {
            setShareType("Merchant");
            // Use the UTM�d URL for the <a href>
            setMerchantEmbedCode(
                `<div><p><a href="${urlWithUtms}"><img style="width: auto; max-height: 200px; margin: 0 auto; display: block;" loading="lazy" src="${props.merchantLogoUrl}" alt="" srcset="${props.merchantLogoUrl}"></a></p></div>`
            );
            return;
        }

        // Product
        if (lower.includes("/prd/") || lower.includes("/prdlink/")) {
            setShareType("Product");
            const idx = lower.includes("/prd/") ? lower.indexOf("/prd/") : lower.indexOf("/prdlink/");
            let baseEmbed = urlWithUtms.slice(0, idx) + "/embed" + urlWithUtms.slice(idx);
            baseEmbed = baseEmbed.replace("/prdlink/", "/prd/");
            const embedUrl = applyUtmsToUrl(baseEmbed);

            const baseBrand =
                baseEmbed.slice(0, baseEmbed.indexOf("/embed") + 6) +
                "/brand" +
                baseEmbed.slice(baseEmbed.indexOf("/embed") + 6);
            const brandUrl = applyUtmsToUrl(baseBrand);

            setProductEmbedCode(
                `<iframe src="${embedUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:320px;"></iframe>`
            );
            setProductEmbedBrandCode(
                `<iframe onload="sendMessage()" id="rpFrame-${parsedShareCode}" src="${brandUrl}" frameborder="0" allowfullscreen style="width:100%;height:100%;min-height:450px;"></iframe><script crossorigin="">function sendMessage(){document.querySelector("#rpFrame-${parsedShareCode}").contentWindow.postMessage("rpMessage","${embedHost}")}window.addEventListener("message",function(e){let isJson=!1;let rpJson;try{rpJson=JSON.parse(e.data);isJson=!0}catch{isJson=!1}if(isJson){if(typeof rpJson.shareCode==="string"){if(typeof rpJson.height==="number"){if(rpJson.height>0){const elements=document.querySelectorAll('iframe[id=rpFrame-'+rpJson.shareCode+']');elements.forEach(element=>{element.style.minHeight=rpJson.height+60+"px"})}}}}})</script>`
            );
            return;
        }

        // Profile
        if (lower.includes("/prf/") || lower.includes("/prflink/")) {
            setShareType("Profile");
            const idx = lower.includes("/prf/") ? lower.indexOf("/prf/") : lower.indexOf("/prflink/");
            let baseEmbed = urlWithUtms.slice(0, idx) + "/embed" + urlWithUtms.slice(idx);
            baseEmbed = baseEmbed.replace("/prflink/", "/prf/");
            const embedUrl = applyUtmsToUrl(baseEmbed);

            setProfileEmbedCode(`<iframe src="${embedUrl}" frameborder="0" allowfullscreen style="width:100%;"></iframe>`);
            return;
        }
    };

    // Keep shareCode in state
    useEffect(() => {
        setShareCode(props.shareCode);
    }, [props.shareCode]);

    // Recompute ALL embed strings whenever the UTM�d link changes
    useEffect(() => {
        const u = shareCodeWithUtms || shareCode;
        if (!u) return;
        computeEmbedsFromShareCode(u);
    }, [shareCodeWithUtms]); // <- reacts to UTM changes too

    // Build email HTML when type or UTM�d link changes
    useEffect(() => {
        if (shareType === "Post") GetPostEmailHtml("post");
        else if (shareType === "Blog") GetPostEmailHtml();
        else if (shareType === "Product") GetProductEmailHtml();
        // Merchant/Profile: no email embed
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shareCodeWithUtms, shareType]);

    // Subdomain helpers (these update base shareCode; UTMs will be reapplied via memo)
    const addShareSubdomainMerchant = async (id) => {
        let route = "/api/Merchant/GetMerchant?id=" + id;
        let merchant = await getRequest(route);

        if (!!merchant && window.location.host.toLowerCase().includes("app.rockp") && !!merchant.shareSubdomain) {
            let url = new URL(props.shareCode);
            url.hostname = `${merchant.shareSubdomain}.rockporch.com`;
            setShareCode(url.toString());
        }
    };

    const handleGoogleAnalytics4 = () => {
        window.gtag("event", "Share_Modal_" + shareType, {
            send_to: "G-9F2DZRE5FG",
            event_category: "Button",
            event_label: `Share Modal ` + shareType,
        });
    };

    const addShareSubdomainProduct = async (shareCodeParam) => {
        let route = "/api/Merchant/GetMerchantByProductShareCode?shareCode=" + shareCodeParam;
        let merchant = await getRequest(route);

        if (!!merchant && window.location.host.toLowerCase().includes("app.rockp") && !!merchant.shareSubdomain) {
            let url = new URL(props.shareCode);
            url.port = "";
            url.hostname = `${merchant.shareSubdomain}.rockporch.com`;
            setShareCode(url.toString());
        }
    };

    let renderCopiedText = () => {
        if (showCopied) {
            setTimeout(() => {
                setCopiedText(false);
            }, 500);
            return <i className="fas fa-clipboard-check"></i>;
        }
        return "Copy";
    };

    let renderCopiedText2 = () => {
        if (showCopied2) {
            setTimeout(() => {
                setCopiedText2(false);
            }, 500);
            return <i className="fas fa-clipboard-check"></i>;
        }
        return "Copy";
    };

    let renderCopiedText3 = () => {
        if (showCopied3) {
            setTimeout(() => {
                setCopiedText3(false);
            }, 500);
            return <i className="fas fa-clipboard-check"></i>;
        }
        return "Copy";
    };

    let renderCopiedText4 = () => {
        if (showCopied4) {
            setTimeout(() => {
                setCopiedText4(false);
            }, 500);
            return <i className="fas fa-clipboard-check"></i>;
        }
        return "Copy";
    };

    if (!!referralShareCode) {
        return (
            <div className="col-md-6 text-center" style={props.customStyle}>
                <div className="share-block pb-0" style={props.shareBlockStyle}>
                    <h5 className="mb-3">
                        Copy and Send the Personalized Link Below to Refer your Creator Friends to RockPorch
                    </h5>
                    <h6 className="mb-3 font-italic" style={{ fontSize: "14px" }}>
                        Get paid for referring new Creators!
                    </h6>

                    <p className="mb-4" style={{ fontSize: "12px" }}>
                        When you refer a fellow passion-driven Creator to RockPorch, we'll pay you 2.5% of the sales they
                        generate through RockPorch for 12 MONTHS <img style={{ verticalAlign: "top" }} src="/images/flame.png" />
                        <br />
                        <i>(don't worry... it doesn't come out of their commissions!)</i>
                    </p>

                    <div className="clipboard mb-4">
                        <input type="text" disabled defaultValue={referralShareCode} id="myInput" onChange={() => null} />
                        <button
                            className="btn"
                            onClick={() => {
                                navigator.clipboard.writeText(referralShareCode);
                                setCopiedText(true);
                                handleGoogleAnalytics4();
                            }}
                        >
                            {renderCopiedText()}
                        </button>
                    </div>
                </div>

                <h6 className="text-uppercase">QR Code</h6>
                {qrImage ? (
                    <div style={{ marginBottom: "30px" }}>
                        <img src={qrImage} alt="QR Code" style={{ width: "128px", height: "128px" }} />
                    </div>
                ) : null}
                <div ref={qrCodeRefCallback} style={{ display: "none" }}>
                    <QRCodeCanvas value={referralShareCode} size={128} />
                </div>
            </div>
        );
    }

    // Show Advanced Options for Profile links (expand later by adding types)
    const SHOW_TYPES = ["Profile", "Post", "Blog", "Locker", "Merchant", "Product", "Registration"];
    const showAdvanced = SHOW_TYPES.includes(shareType);

    return (
        <div className="col-md-6 text-center" style={props.customStyle}>
            <div className="share-block" style={props.shareBlockStyle}>
                <h5 className="mb-4">Share it with the world!</h5>

                {postEmbedCode != null || lockerEmbedCode != null ? <h6 className="text-uppercase">Link</h6> : <></>}
                <div className="clipboard mb-4">
                    <input type="text" disabled value={shareCodeWithUtms || ""} onChange={() => null} />
                    <button
                        className="btn"
                        onClick={() => {
                            navigator.clipboard.writeText(shareCodeWithUtms || "");
                            setCopiedText(true);
                            handleGoogleAnalytics4();
                        }}
                    >
                        {renderCopiedText()}
                    </button>
                </div>

                {props.children}

                {postEmbedCode != null ? (
                    <>
                        <h6 className="text-uppercase">Blog Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input type="text" disabled defaultValue={postEmbedCode} id="myInput" onChange={() => null} />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(postEmbedCode);
                                    setCopiedText2(true);
                                }}
                            >
                                {renderCopiedText2()}
                            </button>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {blogEmbedCode != null ? (
                    <>
                        <h6 className="text-uppercase">Blog Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input type="text" disabled defaultValue={blogEmbedCode} id="myInput" onChange={() => null} />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(blogEmbedCode);
                                    setCopiedText2(true);
                                }}
                            >
                                {renderCopiedText2()}
                            </button>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {lockerEmbedCode != null ? (
                    <>
                        <h6 className="text-uppercase">Blog Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input type="text" disabled defaultValue={lockerEmbedCode} id="myInput" onChange={() => null} />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(lockerEmbedCode);
                                    setCopiedText2(true);
                                }}
                            >
                                {renderCopiedText2()}
                            </button>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {productEmbedBrandCode != null ? (
                    <>
                        <h6 className="text-uppercase">Blog Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input
                                type="text"
                                disabled
                                defaultValue={productEmbedBrandCode}
                                id="myInput"
                                onChange={() => null}
                            />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(productEmbedBrandCode);
                                    setCopiedText3(true);
                                }}
                            >
                                {renderCopiedText3()}
                            </button>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {emailEmbedCode != null ? (
                    <>
                        <h6 className="text-uppercase">Email Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input type="text" disabled defaultValue={emailEmbedCode} id="myInput" onChange={() => null} />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(emailEmbedCode);
                                    setCopiedText3(true);
                                }}
                            >
                                {renderCopiedText3()}
                            </button>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {props.loggedInUser?.isAdmin && postEmbedBrandCode != null ? (
                    <>
                        <h6 className="text-uppercase">ADMIN Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input type="text" disabled defaultValue={postEmbedBrandCode} id="myInput" onChange={() => null} />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(postEmbedBrandCode);
                                    setCopiedText4(true);
                                }}
                            >
                                {renderCopiedText4()}
                            </button>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {props.loggedInUser?.isAdmin && lockerEmbedBrandCode != null ? (
                    <>
                        <h6 className="text-uppercase">ADMIN Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input
                                type="text"
                                disabled
                                defaultValue={lockerEmbedBrandCode}
                                id="myInput"
                                onChange={() => null}
                            />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(lockerEmbedBrandCode);
                                    setCopiedText4(true);
                                }}
                            >
                                {renderCopiedText4()}
                            </button>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {props.loggedInUser?.isAdmin && profileEmbedCode != null ? (
                    <>
                        <h6 className="text-uppercase">ADMIN Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input type="text" disabled defaultValue={profileEmbedCode} id="myInput" onChange={() => null} />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(profileEmbedCode);
                                    setCopiedText4(true);
                                }}
                            >
                                {renderCopiedText4()}
                            </button>
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {merchantEmbedCode != null && (
                    <>
                        <h6 className="text-uppercase">Merchant Logo Embed Code</h6>
                        <div className="clipboard mb-4">
                            <input type="text" disabled defaultValue={merchantEmbedCode} onChange={() => null} />
                            <button
                                className="btn"
                                onClick={() => {
                                    navigator.clipboard.writeText(merchantEmbedCode);
                                    setCopiedText2(true);
                                }}
                            >
                                {renderCopiedText2()}
                            </button>
                        </div>
                    </>
                )}

                {!!shareCode ? (
                    <>
                        <h6 className="text-uppercase">QR Code</h6>
                        {qrImage ? (
                            <div style={{ marginBottom: showAdvanced ? "12px" : "30px" }}>
                                <img src={qrImage} alt="QR Code" style={{ width: "128px", height: "128px" }} />
                            </div>
                        ) : (
                            <></>
                        )}
                        <div ref={qrCodeRefCallback} style={{ display: "none" }}>
                            <QRCodeCanvas
                                key={shareCodeWithUtms}
                                value={shareCodeWithUtms || ""}
                                size={128}
                                level="H"
                                bgColor="#ffffff"
                                fgColor="#000000"
                                style={{
                                    marginBottom: "20px",
                                    pointerEvents: "auto",
                                    userSelect: "text",
                                    touchAction: "manipulation",
                                    WebkitUserSelect: "none",
                                }}
                                imageSettings={{
                                    src: `https://${window.location.host}/favicon.svg`,
                                    x: undefined,
                                    y: undefined,
                                    height: 128 * 0.2,
                                    width: 128 * 0.2,
                                    opacity: 1,
                                    excavate: true,
                                    style: { margin: "10px" },
                                }}
                            />
                        </div>
                    </>
                ) : (
                    <></>
                )}

                {/* Advanced Options � only for Profile for now; expands easily to other types */}
                {!!shareCode && showAdvanced && (
                    <>
                        <div className="text-center" style={{ marginBottom: "20px" }}>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setAdvOpen((x) => !x);
                                }}
                                style={{ textDecoration: "underline", fontSize: 13 }}
                            >
                                {advOpen ? "Hide Advanced Options" : "Advanced Options"}
                            </a>
                        </div>

                        {advOpen && (
                            <div className="row">
                                <div className="col-12 col-md-6 mb-2">
                                    <label className="form-label mb-0">utm_id</label>
                                    <input
                                        className="form-control"
                                        value={utmId}
                                        onChange={(e) => setUtmId(e.target.value)}
                                        maxLength={MAX_UTM_LEN}
                                    />
                                    <p
                                        className="position-relative"
                                        style={{ textAlign: "center", fontSize: "12px", color: "#717171" }}
                                    >
                                        {remaining(utmId)} characters left
                                    </p>
                                </div>

                                <div className="col-12 col-md-6 mb-2">
                                    <label className="form-label mb-0">utm_source</label>
                                    <input
                                        className="form-control"
                                        value={utmSource}
                                        onChange={(e) => setUtmSource(e.target.value)}
                                        maxLength={MAX_UTM_LEN}
                                    />
                                    <p
                                        className="position-relative"
                                        style={{ textAlign: "center", fontSize: "12px", color: "#717171" }}
                                    >
                                        {remaining(utmSource)} characters left
                                    </p>
                                </div>

                                <div className="col-12 col-md-6 mb-2">
                                    <label className="form-label mb-0">utm_medium</label>
                                    <input
                                        className="form-control"
                                        value={utmMedium}
                                        onChange={(e) => setUtmMedium(e.target.value)}
                                        maxLength={MAX_UTM_LEN}
                                    />
                                    <p
                                        className="position-relative"
                                        style={{ textAlign: "center", fontSize: "12px", color: "#717171" }}
                                    >
                                        {remaining(utmMedium)} characters left
                                    </p>
                                </div>

                                <div className="col-12 col-md-6 mb-2">
                                    <label className="form-label mb-0">utm_name</label>
                                    <input
                                        className="form-control"
                                        value={utmName}
                                        onChange={(e) => setUtmName(e.target.value)}
                                        maxLength={MAX_UTM_LEN}
                                    />
                                    <p
                                        className="position-relative"
                                        style={{ textAlign: "center", fontSize: "12px", color: "#717171" }}
                                    >
                                        {remaining(utmName)} characters left
                                    </p>
                                </div>

                                <div className="col-12 col-md-6 mb-2">
                                    <label className="form-label mb-0">utm_content</label>
                                    <input
                                        className="form-control"
                                        value={utmContent}
                                        onChange={(e) => setUtmContent(e.target.value)}
                                        maxLength={MAX_UTM_LEN}
                                    />
                                    <p
                                        className="position-relative"
                                        style={{ textAlign: "center", fontSize: "12px", color: "#717171" }}
                                    >
                                        {remaining(utmContent)} characters left
                                    </p>
                                </div>

                                <div className="col-12 col-md-6 mb-2">
                                    <label className="form-label mb-0">utm_term</label>
                                    <input
                                        className="form-control"
                                        value={utmTerm}
                                        onChange={(e) => setUtmTerm(e.target.value)}
                                        maxLength={MAX_UTM_LEN}
                                    />
                                    <p
                                        className="position-relative"
                                        style={{ textAlign: "center", fontSize: "12px", color: "#717171" }}
                                    >
                                        {remaining(utmTerm)} characters left
                                    </p>
                                </div>
                            </div>
                        )}
                    </>
                )}

                <div className="social-share d-flex justify-content-center">
                    <TwitterIcon shareCode={shareCodeWithUtms || props.shareCode} />
                    <FacebookIcon shareCode={shareCodeWithUtms || props.shareCode} />
                    <MailIcon shareCode={shareCodeWithUtms || props.shareCode} />
                    <MobileShare shareCode={shareCodeWithUtms || props.shareCode} />
                </div>
            </div>
        </div>
    );
};

export default ShareBlock;
